module.exports = __webpack_public_path__ + "static/media/level1-2c.be3c45a7.mp3";